module.exports = __webpack_public_path__ + "img/Picture24.e06d9440.png";